<div class="myvf-ui-spinner-overlay" [class.myvf-ui-spinner-show]="show">
  <div class="myvf-ui-spinner-spinner">
    <i class="myvf-icon-spinner"></i>
  </div>
  <div class="myvf-ui-spinner-text" [innerHTML] = "text"></div>
</div>
